import { types } from './types';

export const setGetMailingAction = (payload) => {
  return {
    type: types.SET_GET_MAILING,
    payload,
  }
}

export const setGetMailingUsersAction = (payload) => {
  return {
    type: types.SET_GET_MAILING_USERS,
    payload,
  }
}

export const setGetMailingStatisticsCountGameAction = (payload) => {
  return {
    type: types.SET_GET_MAILING_STATISTICS_COUNT_OPEN_GAME,
    payload
  }
}

export const setGetMailingStatisticsCountReplenishmentAction = (payload) => {
  return {
    type: types.SET_GET_MAILING_STATISTICS_COUNT_REPLENISHMENT,
    payload
  }
}

export const setGetMailingStatisticsCountTransactionAction = (payload) => {
  return {
    type: types.SET_GET_MAILING_STATISTICS_COUNT_TRANSACTION,
    payload
  }
}


export const setGetMailingStatisticsCountWithdrawalsAction = (payload) => {
  return {
    type: types.SET_GET_MAILING_STATISTICS_COUNT_WITHDRAWALS,
    payload
  }
}

export const setGetMailingStatisticsDashboardAction = (payload) => {
  return {
    type: types.SET_GET_MAILING_STATISTICS_DASHBOARD,
    payload
  }
}

export const setGetMailingStatisticsScrollerUsersOpenGameAction = (payload) => {
  return {
    type: types.SET_GET_MAILING_STATISTICS_SCROLLER_USERS_OPEN_GAME,
    payload
  }
}

export const setGetMailingStatisticsScrollerOpenGameByUserAction = (payload) => {
  return {
    type: types.SET_GET_MAILING_STATISTICS_SCROLLER_OPEN_GAME_BY_USER,
    payload
  }
}

export const setGetMailingStatisticsScrollerUsersDepositsAction = (payload) => {
  return {
    type: types.SET_GET_MAILING_STATISTICS_SCROLLER_USERS_DEPOSITS,
    payload
  }
}

export const setGetMailingStatisticsScrollerUsersDepositsByUserAction = (payload) => {
  return {
    type: types.SET_GET_MAILING_STATISTICS_SCROLLER_USERS_DEPOSITS_BY_USER,
    payload
  }
}


export const setGetMailingStatisticsScrollerUsersTransactionsAction = (payload) => {
  return {
    type: types.SET_GET_MAILING_STATISTICS_SCROLLER_USERS_TRANSACTIONS,
    payload
  }
}

export const setGetMailingStatisticsScrollerUsersTransactionsByUserAction = (payload) => {
  return {
    type: types.SET_GET_MAILING_STATISTICS_SCROLLER_USERS_TRANSACTIONS_BY_USER,
    payload
  }
}

export const setGetMailingStatisticsScrollerUsersWithdrawalsAction = (payload) => {
  return {
    type: types.SET_GET_MAILING_STATISTICS_SCROLLER_USERS_WITHDRAWALS,
    payload
  }
}

export const setGetMailingStatisticsScrollerUsersWithdrawalsByUserAction = (payload) => {
  return {
    type: types.SET_GET_MAILING_STATISTICS_SCROLLER_USERS_WITHDRAWALS_BY_USER,
    payload
  }
}

export const setGetMailingStatisticsScrollerUsersWithdrawalsByCurrencyAction = (payload) => {
  return {
    type: types.SET_GET_MAILING_STATISTICS_SCROLLER_USERS_WITHDRAWALS_BY_CURRENCY,
    payload
  }
}

export const setGetMailingStatisticsScrollerUsersDepositsByCurrencyAction = (payload) => {
  return {
    type: types.SET_GET_MAILING_STATISTICS_SCROLLER_USERS_DEPOSITS_BY_CURRENCY,
    payload
  }
}
